
import type { PropOptions, VueConstructor } from 'vue';
import Vue from 'vue';

export type BravadoCardItem = {
  logo?: VueConstructor<Vue>;
  image?: string;
  title: string;
  subtitle: string;
  color:
    | 'platinum-linear'
    | 'silver-linear'
    | 'gold-linear'
    | 'purple-linear'
    | 'cyan-gradient'
    | 'purple-hover'
    | 'purple-1'
    | 'purple-3'
    | 'purple-4'
    | 'cyan-0'
    | 'cyan-1'
    | 'cyan-2'
    | 'cyan-3'
    | 'brand';
  badge?: string;
  points?: string[];
  animation?: string;
  link?: string;
};

type BravadoCardProps = {
  item: BravadoCardItem;
  size: number;
  variant: 'primary' | 'secondary';
};

export default Vue.extend({
  name: 'BravadoItemCard',
  props: {
    item: {
      type: Object,
      required: true,
    } as PropOptions<BravadoCardProps['item']>,
    variant: {
      type: String,
      default: 'primary',
    } as PropOptions<BravadoCardProps['variant']>,
    size: {
      type: Number,
      default: 30,
    } as PropOptions<BravadoCardProps['size']>,
  },
  computed: {
    classes() {
      const colorClass = this.item.color ? ` bravado-card--${this.item.color}` : '';
      const variantClass = this.variant ? `bravado-card--${this.variant}` : '';

      return `bravado-card ${colorClass} ${variantClass}`;
    },
  },
});
